'use strict';

export default function f($filter) {
  'ngInject';

  var translateFilter = $filter('translate');

  return function (language) {
    language = language || '';

    return translateFilter('LANGUAGES.' + language.toUpperCase());
  };
}



// WEBPACK FOOTER //
// ./app/src/filters/language.js